var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('image-cropper',{attrs:{"imgUrl":'https://d8dnjyv38gzts.cloudfront.net/watermarked/1654789752778MtObg.png'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }